import { random, round2Str } from "../helpers/helpers";
import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

export const generateThLatestDashboardDemo = () => {
    const now = new Date();
    const formattedDate = `${now
        .getDate()
        .toString()
        .padStart(2, "0")}-${now.toLocaleString("default", {
        month: "short",
    })}-${now.getFullYear().toString().slice(-2)} ${now
        .getHours()
        .toString()
        .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;

    // Flatten meters → sensors
    const sensors = thMeterSensorRegistry.flatMap((meter) =>
        meter.sensors.map((sensor) => ({
            sensor_id: sensor.sensor_id,
            meter_id: meter.meter_id,
            sensor_name: sensor.sensor_name,
            location: meter.location,

            status: "Online",
            last_seen: formattedDate,

            temperature: round2Str(
                random(sensor.temp_range[0], sensor.temp_range[1])
            ),
            humidity: round2Str(
                random(sensor.humi_range[0], sensor.humi_range[1])
            ),
        }))
    );

    return {
        total: sensors.length,
        active: sensors.length,
        inactive: 0,
        sensors,
    };
};
